<template>
  <div>
    <el-dialog
        :title="$t('text.reviewApproval')"
        :visible="isShowAdoptDialog"
        width="30%"
        @open="init"
        @close="handleDialog"
        :close-on-click-modal="false"
    >
      <div>
        <div style="font-size: 16px; display: flex">
          <i
              class="el-icon-info"
              style="color: #e6a23c; font-size: 22px; margin-right: 6px"
          ></i
          >{{ $t('message.confirmReviewApproval') }}
        </div>
        <p>
          <el-form ref="form" :model="form" :rules="rules" label-width="170px">
            <el-form-item
                :label="$t('text.disbursementAccount')"
                prop="paymentAccount"
                v-if="type === 'withdraw'">
              <el-input
                  type="text"
                  size="small"
                  :placeholder="$t('message.inputPaymentAccount')"
                  v-model="form.paymentAccount"
                  show-word-limit maxlength="42"
              ></el-input>
            </el-form-item>

            <div>
              <el-form-item :label="$t('text.rechargeAmount')" prop="inputReason" v-if="this.form.type == '00'">
                <el-input
                    type="text"
                    :placeholder="$t('message.inputReason')"
                    v-model="form.amount"
                    :disabled="form.amount != null"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('text.rechargeType')" prop="selectionType" v-if="this.form.type == '00'">
                <el-select
                    v-model="form.selectionType"
                    filterable
                    popper-class="eloption">
                  <el-option :label="$t('text.rechargeUSDT')" value="00"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('text.rechargeExchangeRate')" prop="rechargeExchangeRate"
                            v-if="this.form.selectionType == '00'">
                <el-input
                    type="text"
                    :placeholder="$t('message.inputReason')"
                    v-model="form.rechargeExchangeRate"
                    @input="rechargeInput"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('text.rechargeUSDTAmount')" prop="rechargeUSDAmount"
                            v-if="this.form.selectionType == '00'">
                <el-input
                    type="text"
                    v-model="form.rechargeUSDAmountView"
                    disabled
                ></el-input>
              </el-form-item>
            </div>


            <div>
              <el-form-item :label="$t('text.withdrawalAmount')" prop="inputReason" v-if="this.form.type == '01'">
                <el-input
                    type="text"
                    :placeholder="$t('message.inputReason')"
                    v-model="form.amount"
                    :disabled="form.amount != null"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('text.withdrawalType')" prop="selectionType" v-if="this.form.type == '01'">
                <el-select
                    v-model="form.selectionType"
                    filterable
                    popper-class="eloption">
                  <el-option :label="$t('text.returnU')" value="01"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('text.withdrawExchangeRate')" prop="withdrawExchangeRate"
                            v-if="this.form.selectionType == '01'">
                <el-input
                    type="text"
                    :placeholder="$t('message.inputReason')"
                    v-model="form.withdrawExchangeRate"
                    @input="withdrawInput"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('text.withdrawUSDTAmount')" prop="withdrawUSDAmount"
                            v-if="this.form.selectionType == '01'">
                <el-input
                    type="text"
                    v-model="form.withdrawUSDAmountView"
                    disabled
                ></el-input>
              </el-form-item>
            </div>

            <el-form-item :label="$t('text.remark')" prop="approveRemark">
              <el-input
                  type="textarea"
                  :placeholder="$t('message.inputReason')"
                  v-model="form.approveRemark"
              ></el-input>
            </el-form-item>
          </el-form>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    rowData: '',
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    isShowAdoptDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        paymentAccount: '',
        type: '',
        orderId: '',
        status: '01',
        approveRemark: '',
        amount: '',
        selectionType: '',
        rechargeExchangeRate: '',
        withdrawExchangeRate: '',
      },
      rules: {
        paymentAccount: [
          {required: true, message: this.$t('message.paymentAccountRequiredError'), trigger: 'blur'},
          {max: 42, message: this.$t('message.paymentAccountLengthError'), trigger: 'blur'},
        ],
        approveRemark: [
          {required: true, message: this.$t('message.inputApprovalReason'), trigger: 'blur'},
        ],
        rechargeExchangeRate: [
          {required: true, message: this.$t("message.inputRate"), trigger: ["change", "blur"]},
          {pattern: /^\d+(\.\d+)?$/, message: this.$t("message.numericError"), trigger: ["change", "blur"]}
        ],
        withdrawExchangeRate: [
          {required: true, message: this.$t("message.inputRate"), trigger: ["change", "blur"]},
          {pattern: /^\d+(\.\d+)?$/, message: this.$t("message.numericError"), trigger: ["change", "blur"]}
        ],
        selectionType: [
          {required: true, message: this.$t("message.chooseOne"), trigger: ["change", "blur"]},
        ],
      },
    }
  },
  methods: {
    init() {
      this.form.orderId = this.id
      if (this.rowData != null) {
        this.form.amount = this.rowData.amount / 100;
        this.form.rechargeExchangeRate = this.rowData.rechargeExchangeRate;
        this.form.type = this.rowData.type;
      }
    },
    handleDialog() {
      this.form = {
        orderId: '',
        status: '01',
        selectionType: '',
        type: '',
        approveRemark: '',
        paymentAccount: '',
        amount: '',
        rechargeExchangeRate: '',
        rechargeUSDAmount: '',
        rechargeUSDAmountView: '',
        withdrawExchangeRate: '',
        withdrawUSDAmount: '',
        withdrawUSDAmountView: '',
      }
      this.$refs['form'].resetFields()
      this.$emit('update:isShowAdoptDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            ...this.form,
          }
          this.$axios
              .post('/depositWithdraw/approveDepositWithdraw', params)
              .then(res => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                    type: 'success',
                  })
                  this.$emit('update:isShowAdoptDialog', false)
                  this.$bus.$emit('refresh') //通知刷新
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                  })
                }
              })
        }
      })
    },
    rechargeInput(value) {
      if (value > 0) {
        this.form.rechargeUSDAmount = Math.round(this.form.amount * 100 / this.form.rechargeExchangeRate)
        this.form.rechargeUSDAmountView = (this.form.amount / this.form.rechargeExchangeRate)
      } else {
        this.form.rechargeUSDAmount = 0;
        this.form.rechargeUSDAmountView = 0;
      }
    },
    withdrawInput(value) {
      if (value > 0) {
        this.form.withdrawUSDAmount = Math.round(this.form.amount * 100 / this.form.withdrawExchangeRate)
        this.form.withdrawUSDAmountView = (this.form.amount / this.form.withdrawExchangeRate)
      } else {
        this.form.withdrawUSDAmount = 0;
        this.form.withdrawUSDAmountView = 0;
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>